module.exports = __webpack_public_path__ + "static/RockoUltraFLF-c4481537dd26613e629ea38798575c59.woff";